export const PlayerLevelBaslineMetrics = [
    {
      "is_key_metric": false,
      "decimal_places": 0,
      "metric_id": 9999999,
      "order": 9999999,
      "visible": true,
      "name": "Bodyweight",
      "key": "bodyweight_baseline",
      "unique_identifier": "bw"
    }
  ];